<div class="container card">
  <div class="card-body">
    <h4 class="mb-3" i18n="@@editPassword">Edit password</h4>
    <form [formGroup]="form" (ngSubmit)="submit.next()">
      @if (notoken()) {
        <div class="row">
          <label for="currentPassword" class="col-sm-3 col-form-label" i18n="@@currentPassword">Current password</label>
          <div class="col">
            <input
              id="currentPassword"
              type="password"
              class="form-control"
              formControlName="currentPassword"
              [class.is-invalid]="form.controls.currentPassword.invalid"
            />
            @if (form.controls.currentPassword.hasError('required') && form.controls.currentPassword.touched) {
              <p class="invalid-feedback" i18n="@@requiredCurrentPassword">Current password is required.</p>
            } @else {
              <p class="invalid-feedback d-block invisible">placeholder</p>
            }
          </div>
        </div>
      }

      <div class="row">
        <label for="newPassword" class="col-sm-3 col-form-label" i18n="@@newPassword">New password</label>
        <div class="col">
          <input id="newPassword" type="password" class="form-control" formControlName="newPassword" [class.is-invalid]="form.controls.newPassword.invalid" />
          @if (form.controls.newPassword.invalid) {
            @if (form.controls.newPassword.hasError('required')) {
              <p class="invalid-feedback" i18n="@@requiredPassword">The password is required</p>
            } @else {
              @if (form.controls.newPassword.hasError('pattern')) {
                <p class="invalid-feedback" i18n="@@passwordPatternMismatch">
                  The password must contain at least one uppercase letter, one lowercase letter, one number, and one special character
                </p>
              } @else {
                @if (form.controls.newPassword.hasError('minlength')) {
                  <p class="invalid-feedback" i18n="@@passwordMinLength">The password must be at least 12 characters long</p>
                }
              }
            }
          } @else {
            <p class="invalid-feedback d-block invisible">placeholder</p>
          }
        </div>
      </div>

      <div class="row">
        <label for="confirmPassword" class="col-sm-3 col-form-label" i18n="@@confirmNewPassword">Confirm new password</label>
        <div class="col">
          <input
            id="confirmPassword"
            type="password"
            class="form-control"
            formControlName="confirmPassword"
            [class.is-invalid]="form.controls.confirmPassword.invalid"
          />
          @if (form.controls.confirmPassword.invalid && form.controls.confirmPassword.touched) {
            <p class="invalid-feedback" i18n="@@confirmNewPasswordRequired">Please confirm the new password.</p>
          } @else {
            <p class="invalid-feedback d-block invisible">placeholder</p>
          }
        </div>
      </div>
      @if (form.hasError('passwordMismatch') && (form.controls.confirmPassword.touched || form.controls.newPassword.touched)) {
        <p class="alert alert-danger" role="alert" i18n="@@passwordMismatch">The new password and confirmation do not match.</p>
      } @else {
        @if (form.hasError('passwordSameAsOld') && (form.controls.newPassword.touched || form.controls.currentPassword.touched)) {
          <p class="alert alert-danger" role="alert" i18n="@@passwordSameAsOld">The new password must be different from the current password.</p>
        } @else {
          <p class="alert alert-danger invisible">placeholder</p>
        }
      }
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid" i18n="@@changePassword">Change password</button>
      </div>
    </form>
    @if (notoken()) {
      <div>
        @if (passExpiration()) {
          <p class="mt-3" i18n="@@passwordExpirationInfo">Your password will expire on {{ passExpiration() | date: 'longDate' }}.</p>
        } @else {
          <p class="mt-3" i18n="@@passwordNoExpirationInfo">Your password does not have an expiration date.</p>
        }
      </div>
      <!-- <div>
        <hr />
        <h4 class="mb-3" i18n="@@otpAuthenticator">OTP Authenticator</h4>
        <button type="button" class="btn btn-outline-dark" (click)="toggle.next()">
          @if (otpExists()) {
            <span i18n="@@revokeOtpAuthenticator">Revoke OTP Authenticator</span>
          } @else {
            <span i18n="@@addOtpAuthenticator">Add OTP Authenticator</span>
          }
        </button>
      </div> -->
    }
  </div>
</div>
